<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  formatSalesTableDate,
  salesDeadlineLabel,
  salesDeadlineState,
  salesPaymentLabels,
  salesReceiptLabel,
} from './salesTransactionListCells';

const props = defineProps({
  transaction: { type: Object, required: true },
});

const { t } = useI18n();
const profile = computed(() => props.transaction.profile || {});
const postSale = computed(() => props.transaction.post_sale || {});
const emptyValue = computed(() => t('SALES.TABLE.EMPTY_VALUE'));
const signatureDate = computed(() => profile.value.data_assinatura);
const writingDeadline = computed(
  () => profile.value.data_previsao_escritura || profile.value.prazo_escritura
);
const paymentLabels = computed(() =>
  salesPaymentLabels(profile.value, t, emptyValue.value)
);
const statusDeadline = computed(() => postSale.value.status_due_at);
const statusDeadlineState = computed(() => salesDeadlineState(postSale.value));
const statusDeadlineLabel = computed(() =>
  salesDeadlineLabel(statusDeadlineState.value, t)
);
const receiptLabel = computed(() =>
  salesReceiptLabel(profile.value, t, emptyValue.value)
);
const formatDate = value => formatSalesTableDate(value, emptyValue.value);
</script>

<template>
  <td class="whitespace-nowrap p-4 text-lais-text-body">
    {{ formatDate(signatureDate) }}
  </td>
  <td class="p-4 text-lais-text-body">
    <p>{{ formatDate(writingDeadline) }}</p>
    <span class="text-xs text-lais-text-muted">
      {{ profile.prazo_escritura || emptyValue }}
    </span>
  </td>
  <td class="p-4 text-lais-text-body">{{ paymentLabels }}</td>
  <td class="p-4 text-lais-text-body">
    {{ postSale.responsible?.name || emptyValue }}
  </td>
  <td class="p-4">
    <span class="font-semibold text-lais-text-body">
      {{ postSale.status_label || postSale.status || emptyValue }}
    </span>
    <span class="mt-1 block text-xs text-lais-text-muted">
      {{ formatDate(statusDeadline) }}
    </span>
    <span
      v-if="statusDeadlineState"
      class="mt-1 block text-xs font-semibold"
      :class="
        statusDeadlineState === 'overdue'
          ? 'text-lais-danger'
          : 'text-emerald-600'
      "
    >
      {{ statusDeadlineLabel }}
    </span>
  </td>
  <td class="p-4 text-lais-text-body">{{ receiptLabel }}</td>
</template>
